export default "__VITE_ASSET__Ba$WbMZZ__"